var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBtnActionbarHome32 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M6.799 13.735a2 2 0 0 1 .826-1.62l7.262-5.26a2 2 0 0 1 2.357.007l7.148 5.253a2 2 0 0 1 .815 1.612V23.84a2 2 0 0 1-2.014 2l-14.408-.098a2 2 0 0 1-1.986-2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M12.5 19.65h7"
})));
export default SvgBtnActionbarHome32;